import { Entity, TemporalEntityId } from './common.types'

export function newEntity() {
  return {
    id: TemporalEntityId.new,
    createdAt: new Date(),
    updatedAt: new Date(),
  }
}

export function isNewEntity({ id }: Pick<Entity, 'id'>) {
  return id === TemporalEntityId.new
}
